export default __webpack_public_path__ + "static/footer-bg-99fab90f6d27f1e8059242708118cc3d.png";